export class BookingDiaryShopCtrl implements ng.IComponentController {
  event      : any;

  constructor (
    private $rootScope: ng.IRootScopeService,
    private $scope    : ng.IScope
  ) {}

  $onDestroy () {
    this.$rootScope.$broadcast('pg-tooltip-hide');
  }

  viewDay () : void {
    this.$scope.$emit('viewDay', this.event);
  }
}
